module.exports = __webpack_public_path__ + "static/media/marron.2be03f43.png";